module.exports = __webpack_public_path__ + "static/media/33.edf3c6dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/33.jpg
// module id = 594
// module chunks = 0